var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-template",style:(_vm.cssObject)},[_c('video',{ref:("videoTemplate-" + (_vm.component.id)),attrs:{"width":_vm.width,"loop":_vm.loop,"src":_vm.src,"autoplay":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }